import { string } from "prop-types";

export interface GetFinancialSuppliersResponse {
  id: number;
  name: string;
  title: string;
  logo: string;
}
export interface LoanTemplateIdRequest {
  id: number;
}
export interface GetLoanTemplateSummaryResponse {
  loanTemplateId: number;
  title: string;
  expirationDate: Date;
  expirationDatePersian: string;
  isActive: boolean;
  cardImage: string;
  totalAmountRial: number;
  count: number;
}
export interface GetLoanTemplateInfoResponse {
  loanTemplateId: number;
  loanTemplateTitle: string;
  financialSupplierId: number;
  financialSupplierTitle: string;
  loanTemplateIsActive: boolean;
  clonePermission: boolean;
  cardImage: string;
  loanTemplateSpecification: LoanTemplateSpecification;
  installmentSteps: InstallmentSteps[];
  loanTemplateGuaranteeType: string[];
  documentTypes: DocumentTypes[];
  connectedSuppliers: ConnectedSuppliers[];
  inquiryTypes: InquiryType[];
}
export interface InquiryType {
  id: number;
  title: string;
  enumData: string;
  maxSize_KB: number;
}
export class LoanTemplateSpecification {
  minAgeRestriction?: number | undefined;
  maxAgeRestriction?: number | undefined;
  repaymentPowerPercentage?: number | undefined;
  realProfitPercentage?: number | undefined;
  profitPercentage?: number | undefined;
  repaymentType?: string | undefined;
  repaymentTypeTitle?: string | undefined;
  maxLoanAmountBasedOnVehiclePricePercentage?: number | undefined;
  guarantorsCount?: number | undefined;
  minAmount?: number | undefined;
  maxAmount?: number | undefined;
  expirationDate?: Date | undefined;
  expirationDatePersian?: string | undefined;
  loanTemplateType?: string | undefined;
  loanTemplateTypeTitle?: string | undefined;
  warrantyPercentage?: number | undefined;
  loanTemplateTitle?: string | undefined;
  loanTemplateId?: number | undefined;
  governmentTaxPercent?: number | undefined;
  needCustomerActivationLoanOtp?: string | undefined;
  creditRequestPermission?: string | undefined;
  creditRequestPermissionTitle?: string | undefined;
}

export interface InstallmentSteps {
  key: string;
  stepSpaceByMonth: number;
  installmentCount: number;
  installmentDuration: number;
}

export interface DocumentTypes {
  id: number;
  title: string;
  enumData: string;
  maxSize_KB: number;
  orderIndex: number;
  fileType: string;
  documentGroupId: number;
  documentGroup: string;
  documentGroupTitle: string;
}

export interface ConnectedSuppliers {
  supplierId: number;
  title: string;
  logo: string;
}
export interface CloneTheLoanTemplateResponse {
  loanTemplateId: number;
}
export interface AddSupplierToLoanTemplateRequest {
  supplierId: number;
  loanTemplateId: number;
}

// add model for loanpalns
export interface GetAllLoanTemplatesResponse {
  loanTemplateId: number;
  loanTemplateTitle: string;
  loanTemplateExpireDate: string;
  loanTemplateExpireDatePersian: string;
  minAgeRestriction: number;
  maxAgeRestriction: number;
  repaymentPowerPercentage: number;
  guarantyPercentage: number;
  isLoanTemplatePublic: true;
  isLoanTemplatePublicPersian: string;
  specialStoreTitle: string;
  repaymentType: string;
  repaymentTypeTitle: string;
  walletTypeTitle: string;
  walletTypeLogo: string;
  isActive: boolean;
  walletTypeColorHexCode: string;
  feePaymentType: string;
  feePaymentTypeTitle: string;
}

export interface LoanPlanIdRequest {
  loanTemplateId: number;
}
export interface GetLoanTemplateDetailByIdResponse {
  loanTemplateDetail: GetAllLoanTemplatesResponse;
  organizations: Organization[];
  financialSuppliers: FinancialSuppliers[];
}
export interface Organization {
  title: string;
  financialSupplierTitles: string[];
  financialSupplierTitlesString: string;
  isActive: boolean;
}
export interface FinancialSuppliers {
  logo: string;
  title: string;
  detail: Detail[];
}
export interface Detail {
  interestRate: number;
  minimumAmount: number;
  maximumAmount: number;
  durationByMonth: number;
  stepSpaceByMonth: number;
  guarantorCount: number;
  isActive: boolean;
  customerGuarantyChequeRequired: boolean;
  customerFeePercentage: number;
  supplierFeePercentage: number;
  feePaymentType: string;
  feePaymentTypeTitle: string;
}
